import React from 'react';
import { IoArrowForward } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import ServerImage from './ServerImage';

const TeamSection = () => {
  const navigate = useNavigate();
  
  const teamMembers = [
    {
      id: 1,
      name: 'Nour Elhouda Zraibia',
      role: 'Founder and CEO',
      image: '/team/nour.webp',
      hasImage: true
    },
    {
      id: 2,
      name: 'Zaineb Saidi',
      role: 'UX and graphic designer',
      image: "/team/zaineb.webp",
      hasImage: true
    },
    {
      id: 3,
      name: 'Mohamed Amine Hamdi',
      role: 'Developer',
      image: '/team/medamin.webp',
      hasImage: true
    }
  ];

  return (
    <section className="py-12 md:py-16 px-4 md:px-28 max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex justify-center md:justify-start items-center mb-8 md:mb-16 md:-ml-24">
        <h2 className="text-2xl md:text-4xl lg:text-4xl font-bold text-gray-900">Meet the team</h2>
      </div>

      {/* Team Grid */}
      <div className="grid grid-cols-2 md:grid-cols-7 gap-4 md:gap-0 mb-8 md:mb-0">
        {teamMembers.slice(0, 2).map((member) => (
          <div key={member.id} className="text-center md:hidden">
            {/* Mobile Layout */}
            <div className="relative mb-4">
              {/* Blue Background Rectangle */}
              <div 
                className="w-full aspect-square mx-auto rounded-3xl absolute top-8 left-0 z-0"
                style={{ 
                  backgroundColor: 'var(--primary-blue)',
                  borderRadius: '24px'
                }}
              ></div>
              
              {/* Photo positioned in front of blue background */}
              {member.hasImage && (
                <img 
                  src={member.image} 
                  alt={member.name}
                  fallback="/team/nour.png"
                  className="w-full aspect-[4/5] object-cover object-center mx-auto rounded-3xl relative z-10"
                  style={{ borderRadius: '24px' }}
                />
              )}
            </div>

            {/* Member Info */}
            <div className="text-left px-2">
              <h3 className="text-base font-bold text-gray-900 mb-1">{member.name}</h3>
              <p className="text-sm text-gray-400">{member.role}</p>
            </div>
          </div>
        ))}
        
        {/* Desktop Layout - All members */}
        {teamMembers.map((member) => (
          <div key={`desktop-${member.id}`} className="text-center hidden md:block md:col-span-2">
            {/* Image Container - Photo with blue background behind */}
            <div className="relative mb-6">
              {/* Blue Background Rectangle */}
              <div 
                className="w-60 h-60 mx-auto rounded-3xl absolute top-12 left-1/2 transform -translate-x-1/2 z-0"
                style={{ 
                  backgroundColor: 'var(--primary-blue)',
                  borderRadius: '28px'
                }}
              ></div>
              
              {/* Photo positioned in front of blue background */}
              {member.hasImage ? (
                <img 
                  src={member.image} 
                  alt={member.name}
                  fallback="/team/nour.png"
                  className="w-60 h-72 object-cover mx-auto relative z-10"
                  style={{ borderRadius: '28px' }}
                />
              ) : (
                // Empty space for members without images, showing only blue background
                <div className="w-56 h-72 mx-auto relative z-10"></div>
              )}
            </div>

            {/* Member Info */}
            <div className='text-left px-2 ml-8'>
              <h3 className="text-xl font-bold text-gray-900 ">{member.name}</h3>
              <p className="text-gray-500">{member.role}</p>
            </div>
          </div>
        ))}

        {/* See All Button - Desktop only, takes 1 column */}
        <div className="hidden md:flex md:col-span-1 items-center justify-center">
          <button 
            onClick={() => navigate('/about')}
            className="bg-white px-6 py-3 rounded-full flex items-center gap-2 text-gray-700 hover:text-gray-900 transition-colors"
            style={{ boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)' }}
          >
            <span className="text-lg font-medium">See all</span>
            <IoArrowForward className="w-5 h-5" />
          </button>
        </div>
        
      </div>

      {/* See All Button - Mobile only, centered at bottom */}
      <div className="flex justify-center md:hidden mt-8">
        <button 
          onClick={() => navigate('/about')}
          className="bg-white px-8 py-3 rounded-full flex items-center gap-3 text-gray-700 hover:text-gray-900 transition-colors"
          style={{ boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)' }}
        >
          <span className="text-base font-medium">See all</span>
          <IoArrowForward className="w-5 h-5" />
        </button>
      </div>
    </section>
  );
};

export default TeamSection;